import { curry, path } from "ramda"
import { isString, isNotNullOrEmpty, isNotEmptyString } from "../../validate"
import { isInputText, isChineseInputText, charsForStartForbid } from "./specialChecking"

export default curry((maxLength, { value: str, forminputdata }) => {
  const countryCode = isNotNullOrEmpty(forminputdata) ? path(["region", "country", "id"], forminputdata) : ""
  if (countryCode === "HKG") {
    if (!isString(str)) return false
    if (!isNotEmptyString(str)) return false

    if (maxLength && (str.length <= 0 || str.length > maxLength)) return false

    const allowCharactor = /^([A-Za-z0-9-]){1,20}$/.test(str)

    if (!allowCharactor) return false
    if (str.slice(0, 1).match(charsForStartForbid)) return false
  }

  return true
})
